import { render, staticRenderFns } from "./indexPage.vue?vue&type=template&id=cfd38244&scoped=true&lang=pug&"
import script from "./indexPage.vue?vue&type=script&setup=true&lang=js&"
export * from "./indexPage.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./indexPage.vue?vue&type=style&index=0&id=cfd38244&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfd38244",
  null
  
)

export default component.exports